import { Paper, AppBar, Box, Button, Container, Toolbar, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Cancel, Save } from '@mui/icons-material';
import CardFormFields from './CardFormFields';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { closeEditCard, saveCard } from '../../../../actions/cardsActions';
import { apiV2 } from '../../../../actions';
import Swal from "sweetalert2";
import LoadingBackdrop from '../../../Common/LoadingBackdrop';
import { fetchAllMediaResources } from '../../../../actions/mediaResourceActions';

export default function AddEditCard() {
    const { deckId, id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const saveLoading = useSelector(state => state.cards.loading);
    const [isModified, setModified] = useState(false);

    const [card, setCard] = useState({
        back_image_url: '',
        front_image_url: '',
        is_active: false,
        linked_content_button_icon_url: '',
        linked_content_button_text: '',
        share_image_url: '',
        share_link_description: '',
        subtitle: '',
        target_android_deeplink_url: '',
        target_deeplink_image_url: '',
        target_ios_deeplink_url: '',
        target_web_deeplink_url: '',
        title: '',
    });

    useEffect(() => {
        if (id) {
            setIsLoading(true);
            apiV2.get(`/decks/cards/${id}`)
                .then(response => {
                    setModified(false);
                    setCard(response.data);
                })
                .catch(() => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to load card',
                    });
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [id]);

    useEffect(() => {
        dispatch(fetchAllMediaResources());
    }, [dispatch]);

    const handleChange = e => {
        setModified(true);
        setCard({ ...card, [e.target.name]: e.target.value });
    }

    const handleSave = () => {
        const cardToSave = {
            ...card,
            deck_id: deckId
        }
        setModified(false);
        dispatch(saveCard(cardToSave, () => navigate(`/card-decks/${deckId}/cards`)));
    }

    const handleCancel = () => {
        if (isModified) {
            Swal.fire({
                icon: "warning",
                text: "You have unsaved changes. Are you sure you want to leave?",
                showConfirmButton: true,
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonText: "Save & Close",
                cancelButtonText: "Close Without Saving",
            }).then((result) => {
                if (result.isConfirmed) {
                    handleSave();
                } else {
                    dispatch(closeEditCard(deckId, () => navigate(`/card-decks/${deckId}/cards`)));
                }
            });
        } else {
            dispatch(closeEditCard(deckId, () => navigate(`/card-decks/${deckId}/cards`)));
        }
    }

    return (
        <Container sx={{ paddingBottom: 4 }}>
            <LoadingBackdrop open={isLoading || saveLoading} />
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        {id && card ? `Edit Card: ${card.title}` : 'Add New Card'}
                    </Typography>
                    <Button color="success" onClick={handleSave} startIcon={<Save />} variant="contained" sx={{ marginRight: 2 }}>
                        Save
                    </Button>
                    <Button color="error" startIcon={<Cancel />} variant="contained" onClick={handleCancel}>
                        Cancel
                    </Button>
                </Toolbar>
            </AppBar>
            <Box gap={4}>
                <Paper sx={{ padding: 2 }}>
                    <CardFormFields
                        card={card}
                        handleChange={handleChange}
                    />
                </Paper>
            </Box>
        </Container>
    )
}
